import AxiosInstance from "../Utils/axios/axiosConfig";

export const saveWorkflowSettings = async (body) => {
    const response = await AxiosInstance.put("/workflow/settings/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response.message);
    }
  };

  export const getWorkflowSettings = async (param) => {
    const response = await AxiosInstance.get(`/workflow/settings/?${param}`);
    if (!response.data.error) {
        return response.data;
      } else {
        return Promise.reject(response.message);
      }
  };